import { COMPARISON_ROWS } from "./marketing-content";

const COLUMNS = [
  { key: "philolms", label: "PhiloLMS", highlight: true },
  { key: "koha", label: "Koha", highlight: false },
  { key: "evergreen", label: "Evergreen", highlight: false },
  { key: "alma", label: "Alma", highlight: false },
] as const;

export function MarketingCompare() {
  return (
    <section id="compare" className="container mx-auto px-4 py-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">How PhiloLMS compares</h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          A practical look at PhiloLMS next to Koha, Evergreen, and Ex Libris Alma, focused on how
          libraries actually buy, launch, and run software.
        </p>
      </div>

      <div className="max-w-6xl mx-auto overflow-x-auto rounded-lg border bg-card">
        <table className="w-full min-w-[720px] text-left text-sm">
          <thead>
            <tr className="border-b bg-muted/40">
              <th className="px-4 py-3 font-semibold text-muted-foreground">Capability</th>
              {COLUMNS.map((col) => (
                <th
                  key={col.key}
                  className={`px-4 py-3 font-semibold ${col.highlight ? "text-primary" : ""}`}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPARISON_ROWS.map((row) => (
              <tr key={row.label} className="border-b last:border-0">
                <th className="px-4 py-3 align-top font-medium">{row.label}</th>
                {COLUMNS.map((col) => (
                  <td
                    key={col.key}
                    className={`px-4 py-3 align-top text-muted-foreground ${
                      col.highlight ? "bg-primary/5 text-foreground font-medium" : ""
                    }`}
                  >
                    {row[col.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-4 text-center text-xs text-muted-foreground max-w-3xl mx-auto">
        Comparison is for orientation only. Capabilities and pricing vary by deployment, hosting
        partner, and institutional agreement.
      </p>
    </section>
  );
}
